import React from 'react';
import { ExternalLink, MoreVertical } from 'lucide-react';
import { cn } from '../../lib/utils';
import CardMenu from './CardMenu';

/**
 * Card chrome matching resource grids (Chrono light theme).
 * Presentational only — no data fetching.
 */
export default function LabCard({
  title,
  description,
  accentColor = '#721b1f',
  initial,
  badge,
  selected = false,
  showExternal = false,
  showMenu = false,
  menuItems,
  onClick,
  className,
  as: Component = 'div',
}) {
  const letter = initial || title?.[0]?.toUpperCase() || '?';

  return (
    <Component
      type={Component === 'button' ? 'button' : undefined}
      onClick={onClick}
      className={cn(
        'text-left p-5 rounded-lg bg-shell-card border transition-all duration-200 hover:bg-[#f7f6f2]',
        selected ? 'border-primary' : 'border-shell-card-border hover:border-[#d4d4d4]',
        onClick && Component === 'button' ? 'cursor-pointer w-full' : '',
        className,
      )}>
      <div className="flex items-start justify-between mb-4">
        <div
          className="w-10 h-10 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: `${accentColor}1A` }}>
          <span className="text-sm font-bold" style={{ color: accentColor }}>
            {letter}
          </span>
        </div>
        <div className="flex items-center gap-2">
          {badge ? (
            <span className="text-[10px] font-medium px-2 py-0.5 rounded bg-black/[0.04] text-muted uppercase">
              {badge}
            </span>
          ) : null}
          {showExternal ? <ExternalLink className="w-3.5 h-3.5 text-muted-dim" /> : null}
          {menuItems?.filter(Boolean)?.length ? (
            <CardMenu items={menuItems} />
          ) : showMenu ? (
            <span className="text-muted-dim">
              <MoreVertical className="w-4 h-4" />
            </span>
          ) : null}
        </div>
      </div>
      {title ? (
        <h3 className="text-base font-semibold text-[var(--text-color)] mb-2 truncate">{title}</h3>
      ) : null}
      {description ? (
        <p className="text-sm text-muted leading-relaxed line-clamp-2">{description}</p>
      ) : null}
    </Component>
  );
}
